import { Stack, Typography, Chip } from '@mui/material';
import { fmtQty } from '../styles/ds';

const EPSILON = 1e-9;

/**
 * "3 / 5 מוקצה" progress chip + guidance message for one order line's
 * supplier allocation. Purely presentational — the parent computes
 * allocatedQty from its own rows.
 */
const SupplierAllocationSummary = ({ orderedQty, allocatedQty, unit }) => {
  const ordered  = Number(orderedQty) || 0;
  const diff     = ordered - allocatedQty;
  const complete = Math.abs(diff) < EPSILON;
  const excess   = diff < -EPSILON;

  return (
    <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
      <Chip
        label={`${fmtQty(allocatedQty, unit)} / ${fmtQty(ordered, unit)} מוקצה`}
        size="small"
        sx={{
          fontWeight: 700, fontSize: 11,
          backgroundColor: complete ? '#D4EDDA' : excess ? '#F8D7DA' : '#FFF3CD',
          color:           complete ? '#155724' : excess ? '#721C24' : '#856404',
        }}
      />
      {!complete && (
        <Typography fontSize={11} color={excess ? '#c62828' : '#856404'}>
          {excess
            ? `ההקצאה גדולה מהכמות שהוזמנה ב-${fmtQty(-diff, unit)}`
            : `יש להקצות עוד ${fmtQty(diff, unit)} יחידות`}
        </Typography>
      )}
    </Stack>
  );
};

export default SupplierAllocationSummary;
